import initUpload from "../../../src/js/form/file-upload";

document.addEventListener("DOMContentLoaded", async () => {
	/* webpackChunkName: "clipboard" */
	const { initClipboard } = await import("@utils/clipboard");

	/* webpackChunkName: "tooltip" */
	const { initTooltips } = await import("@utils/tooltip");

	initUpload();
	initClipboard();
	initTooltips();
});
